// @flow
import classNames from "classnames";
import React, { PureComponent } from "react";

type Props = {
  height: number,
  width: number,
  className: any
};

class Plus extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 8 8`}>
        <title>Ícone mais</title>
        <desc>Ícone de sinal de adição</desc>
        <g id="icon-plus">
          <path d="M4,0H4A1,1,0,0,0,3,1V3H1A1,1,0,0,0,0,4H0A1,1,0,0,0,1,5H3V7A1,1,0,0,0,4,8H4A1,1,0,0,0,5,7V5H7A1,1,0,0,0,8,4H8A1,1,0,0,0,7,3H5V1A1,1,0,0,0,4,0Z" />
        </g>
      </svg>
    );
  }
}

export default Plus;
